import React, { forwardRef, useEffect, useState } from "react";
import { GetRef, styled, Switch, SwitchProps } from "tamagui";

export type ToggleProps = Omit<SwitchProps, "children">;

export const Toggle = forwardRef<GetRef<typeof Switch>, ToggleProps>(
  (
    {
      checked: externalChecked,
      onCheckedChange: externalOnCheckedChange,
      ...rest
    },
    ref,
  ) => {
    const [checked, setChecked] = useState(
      externalChecked ?? rest.defaultChecked ?? false,
    );

    const onCheckedChange = (checked: boolean) => {
      if (externalChecked === undefined) {
        setChecked(checked);
      }
      externalOnCheckedChange?.(checked);
    };

    useEffect(() => {
      if (externalChecked !== undefined) {
        setChecked(externalChecked);
      }
    }, [externalChecked]);

    return (
      <StyledSwitch
        ref={ref}
        checked={checked}
        onCheckedChange={onCheckedChange}
        {...rest}
      >
        <StyledThumb />
      </StyledSwitch>
    );
  },
);

const StyledSwitch = styled(Switch, {
  width: 64,
  height: 40,
  backgroundColor: "$color8",
  borderColor: "$color8",
  borderWidth: 0,
  padding: 2,
  variants: {
    checked: {
      true: {
        backgroundColor: "$hgPrimary",
        borderColor: "$hgPrimary",
      },
    },
  } as const,
});

const StyledThumb = styled(Switch.Thumb, {
  width: 36,
  height: 36,
  backgroundColor: "$color9",
  animation: "slow",
});
